<template lang="pug">
  div
    app-divider.margin-medium-top(
      label="LIMITES: ",
      :showBorder="false",
    )
    el-table(
      stripe,
      :data="limitesAux",
    )
      el-table-column(
        label='Direção',
      )
        template(slot-scope='scope')
          validation-provider(:ref="'validationLimites' + scope.$index" rules="required", v-slot="{ errors }")
            el-select.full-width.input(
              :class="{'erro' : errors.length}",
              v-model="limitesAux[scope.$index].direcao",
              :name="'direcao_'+scope.$index",
              @change="$emit('changeLimites', limitesAux)",
              clearable,
            )
              el-option(
                v-for="c in coordenadas",
                :key="c.value"
                :label="c.descricao"
                :value="c.value"
              )
            span.help.erro(v-if="errors.length") {{ errors[0] }}
      el-table-column(
        :formatter="formattedMarcos",
        label='Marcos'
      )
      el-table-column(
        prop='confinante',
        label='Confinantes'
      )
      el-table-column(
        label='Distância (m)',
        prop='distancia'
      )
      el-table-column(
        label='Azimutes',
        prop='azimute',
      )
</template>

<script>
import _ from 'lodash'
import AppDivider from '@/components/AppDivider'

export default {
  components: {
    AppDivider
  },

  props: {
    limites: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      coordenadas: [
        {
          descricao: 'Norte',
          value: 'NORTE'
        },
        {
          descricao: 'Sul',
          value: 'SUL'
        },
        {
          descricao: 'Leste',
          value: 'LESTE'
        },
        {
          descricao: 'Oeste',
          value: 'OESTE'
        },
        {
          descricao: 'Lado esquerdo',
          value: 'LADO_ESQUERDO'
        },
        {
          descricao: 'Lado direito',
          value: 'LADO_DIREITO'
        }
      ],
      limitesAux: []
    }
  },

  created () {
    this.limitesAux = this.limites
  },

  computed: {
  },

  methods: {
    formattedMarcos (prop) {
      return prop.marcoInicial + '/' + prop.marcoFinal
    }
  },
  watch: {
    limites () {
      this.limitesAux = _.cloneDeep(this.limites)
    }
  },
  updated () {
    if (this.limitesAux.some((l, index) => this.$refs['validationLimites' + index].errors && this.$refs['validationLimites' + index].errors.length > 0)) {
      this.limitesAux.forEach((l, index) => this.$refs['validationLimites' + index].validate())
    }
  }
}
</script>

<style scoped lang="scss">

.select-error {
  margin: 0px;
}

/deep/.el-table .cell {
  padding-bottom: 10px;
  padding-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppLimites.vue